export default "__VITE_ASSET__BpB61ft8__"